// @ts-check
import { useQuery } from '@tanstack/react-query';
import api from 'modules/queries/api';

/**
 * @param {import('@tanstack/react-query').UseQueryOptions<import('club-sauce/public/project/index.raw').LWApiPublicProjectCategoriesResultRawI>} [options]
 */
const useProjectCategories = (options) =>
	useQuery({
		queryKey: ['/project/categories'],
		queryFn: () => api.project.apiRaw.categories(),
		...options,
	});

export default useProjectCategories;
